jQuery.validator.addMethod("verifyemail", function(value) {
    if(value) {
        var regex = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:[a-zA-Z0-9](?:\.[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\.[a-zA-Z0-9]{2,6}))$/i;
        return value. match(regex);
    }else {
        return false;
    }
}, "Inserisci un indirizzo email valido"); 

jQuery.validator.addMethod("checkedPrivacy", function(value) { 
        if(value != '0') {
            return true;
        }else {
            return false;
        }
    }, "Accettare la privacy"); 

jQuery.validator.addMethod("verifymultimail", function(value) { 
     if(value) {
        var aCheck;
        var regex = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:[a-zA-Z0-9](?:\.[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\.[a-zA-Z0-9]{2,6}))$/i;
        if(value.indexOf(",") > -1){
            var aEmail = value.split(",");
                var sBagliato = 0;
                $.each(aEmail,function(index,val) {
                    aCheck = [];
                     var sCheck = val.match(regex);
                    if( sCheck ===  null ){
                       sBagliato = 1;
                    }
                });

                if(sBagliato == 1){
                    return false;
                }else{
                    return true;
                }
                
        } else {
            return value.match(regex);
        }
    }else {
        return false;
    }
}, "Inserisci un indirizzo email valido"); 

jQuery.validator.addMethod("checkemail", function(value, element) { 
    var email = $("#email").val();
    var checkemail = $("#emailCheck").val();
    if(email==checkemail)
    {
        return true;
    }
    return false;
}, "Email inserita non uguale alla verifica email."); 

jQuery.validator.addMethod("numberTelefono", function(value) { 
    var regex = /^(?:[0-9+] ?){0,1}(?:[0-9] ?){7,}$/;
    return value.match(regex);
}, "Inserisci un numero di telefono valido"); 

jQuery.validator.addMethod("dateITA", function(value, element) { 
     return value.match(/^\d\d?\/\d\d?\/\d\d\d\d$/);
});

jQuery.validator.addMethod("checkCaptcha", function (value, element) {
    var captchaBasso = $("#captchaBasso").val();
    var dati = "captcha=" + captchaBasso;
    var isSuccess = false;
  
    var v = grecaptcha.getResponse(widgetId1);
    if(v.length == 0)
    {
        isSuccess = false;
    }
    if(v.length != 0)
    {
        $('#captcha').html("");
        isSuccess = true;
    }
    return isSuccess;

}, "Captcha non valido!");

jQuery.validator.addMethod("checkUser", function (value, element) {
            var email = $("#email").val();
            var dati = "email=" + email;
            var isSuccess = false;
            $.ajax({
                type: "POST",
                async: false,
                url: '/src/App/controllers/include/controlloUser.php',
                data: dati,
                success: function (data) {
                    if (data == 'errore')
                    {
                        isSuccess = true;
                    }
                }
            });

            return isSuccess;

        }, "Nessun utente con questa email!");
        

jQuery.validator.addMethod("checkCodiceFiscale", function (value) {
    var cf = value;
    var i;
    var s = 0;
    var set1 = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    var set2 = "ABCDEFGHIJABCDEFGHIJKLMNOPQRSTUVWXYZ";
    var setpari = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    var setdisp = "BAKPLCQDREVOSFTGUHMINJWZYX";
    var validi = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    if (cf == "")
        return false;
    if (cf.length != 16)
        return false;
    cf = cf.toUpperCase();
    for (i = 0; i < 16; i++) {
        if (validi.indexOf(cf.charAt(i)) == -1)
            return false;
    }
    for (i = 1; i <= 13; i += 2)
        s += setpari.indexOf(set2.charAt(set1.indexOf(cf.charAt(i))));
    for (i = 0; i <= 14; i += 2)
        s += setdisp.indexOf(set2.charAt(set1.indexOf(cf.charAt(i))));
    if (s % 26 != cf.charCodeAt(15) - 'A'.charCodeAt(0))
        return false;
    return true;


}, "Inserisci una codice fiscale valido!");


jQuery.extend(jQuery.validator.messages, {
    required: "Campo obbligatorio.",
    remote: "Imposta un valore per questo campo.",
    email: "Inserisci un indirizzo email valido.",
    url: "Inserisci un URL corretto.",
    date: "Inserisci una data valida.",
    dateISO: "Inserisci una data nel formato (ISO).",
    number: "Inserisci un numero valido.",
    digits: "Inserisci un numero positivo valido",
    creditcard: "Inserisci un numero valido di carta di credito.",
    equalTo: "Inserisci nuovamente lo stesso valore.",
    accept: "Inserisci un valore con estensione valida.",
    maxlength: jQuery.validator.format("Inserisci al massimo {0} caratteri."),
    minlength: jQuery.validator.format("Inserisci al minimo {0} caratteri."),
    rangelength: jQuery.validator.format("Inserisci un valore compreso tra {0} e {1} caratteri di lunghezza."),
    range: jQuery.validator.format("Inserisci un valore compreso tra {0} e {1}."),
    max: jQuery.validator.format("Inserisci un valore minore uguale a {0}."),
    min: jQuery.validator.format("Inserisci un valore maggiore uguale a {0}.")
});